import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Image, Modal, Space, notification } from "antd";
import { useState } from "react";
import { CouponService } from "../../services/CouponService";
import moment from "moment";
import { Link } from "react-router-dom";
import CreateCoupon from "./CreateCoupon";


export default function Coupon() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
   

    const [tab, setTab] = useState<string>("coupons")

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Picture',
            align: 'center',
            dataIndex: 'picture',
            key: 'picture',
            render: (value, record) => {
                return <Image src={value?.fullpath} width={80}></Image>
            },
        },
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Category',
            align: 'center',
            dataIndex: 'category',
            key: 'category',
            render: (value, record) => {
                return value?.name_en || 'All'
            },
        },
        {
            title: 'Name',
            align: 'center',
            dataIndex: 'name',
            key: 'name',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Point',
            align: 'center',
            dataIndex: 'point',
            key: 'point',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Is Public',
            align: 'center',
            dataIndex: 'is_public',
            key: 'is_public',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Is Super Deal',
            align: 'center',
            dataIndex: 'is_super_deal',
            key: 'is_super_deal',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Used / Limit',
            align: 'center',
            dataIndex: 'limit',
            key: 'limit',
            render: (value, record) => {
                return <Link to={`code/${record.id}`}>{`${record.usage}/${value}`}</Link>
            },
        },
        {
            title: 'Start Date',
            align: 'center',
            dataIndex: 'start_date',
            key: 'start_date',
            render: (value, record) => {
                return (value && moment(value).isValid()) ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'Expired Date',
            align: 'center',
            dataIndex: 'expired_date',
            key: 'expired_date',
            render: (value, record) => {
                return (value && moment(value).isValid()) ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div>
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])


    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await CouponService.getCoupons(payload)
    
      
        return res
    }


    const onChange = (key: string) => {
        console.log(key);
        setTab(key)
    };

    const onDelete = async (id: number) => {
        const res = await CouponService.deleteCoupon(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }





    return (
        <>

            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateCoupon
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateCoupon>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Coupon',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Coupon"
                columns={columns}
                onLoadData={onLoadData}
            />

        </>
    )
}
